import React, { useEffect, useState, useContext } from "react";
import Footerlogo from '../assets/img/footer logo.svg';
import Footer1 from '../assets/img/Frame 2147207307.svg';
import Footer2 from '../assets/img/Frame 2147207308.svg';
import Footer3 from '../assets/img/Frame 2147207309.svg';
import Footer4 from '../assets/img/Frame 2147207310.svg';
import Footer5 from '../assets/img/Frame 2147207312.svg';
import { useNavigate } from "react-router-dom";
import { LanguageContext } from '../pages/languagecontext'
import API from '../pages/Services/Baseservice';
import { slugify } from '../utils/slugify';

const Footer = () => {
  const { selectedLanguage } = useContext(LanguageContext);
  const [DropDown, setDropDown] = useState([])
  const [loading, setLoading] = useState(true);
  const [contactUsLinks, setContactUsLinks] = useState([]);
  const footerListicon = () => {
    let req = {
      language_id: selectedLanguage.id
    }
    API.post("webContact_List/webCondition", req)
      .then((res) => {
        if (res.data.success === true) {
          const data = res.data.data;
          setContactUsLinks(data.socialLinks || []);
        }
      })
  }
  const navigate = useNavigate();
  const handleClick = (item) => {
    if (item.listofservice_id) {
      const slug = slugify(item.heading || "");
      navigate(`/servicedetail/${slug}`, {
        state: {
          id: item.listofservice_id,
          language_id: selectedLanguage.id,
        },
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      console.log("No route defined for:", item.listofservice_id);
    }
  };
  useEffect(() => {
    if (selectedLanguage?.id) {
      dropdown();
      footerListicon()

    }
  }, [selectedLanguage.id]);

  const dropdown = () => {
    setLoading(true);
    let req = { language_id: selectedLanguage.id };

    API.post("weblistofservice_list/webCondition", req)
      .then((res) => {
        if (res.data.success === true) {
          const services = (res.data.data.data || []).slice().sort((a, b) => a.order_by - b.order_by);
          setDropDown(services);


          localStorage.setItem("DropDownValue", JSON.stringify(services));
        }
      })
      .finally(() => setLoading(false));
  };
  const faq = () => {
    navigate("/faq");
  }
  const news = () => {
    navigate("/news")
  }
  const blog = () => {
    navigate("/blog");
  }
  const termsAndConditions = () => {
    navigate("/termsandconditions")
  }

  const PrivacyPolicy = () => {
    navigate("/PrivacyPolicy");
  }

  const ContactUs = () => {
    navigate("/contactus")
  }
  const checkEligibility = () => {
    navigate("/checkeligibility")
  }
  const Book = () => {
    navigate("/bookingform")
  }
  return (
    <footer>
      <div className="container px-3">
        <div className="row gy-4">
          <div className="col-md-4 col-lg-2">
            <div className="footer-logo d-flex justify-content-center mb-2">
              <img src={Footerlogo} alt="Asra Logo" />
            </div>

            <div className="social-icons d-flex justify-content-around mt-3">
              {contactUsLinks.length > 0 && contactUsLinks

                .map((item) => (
                  <a
                    key={item.sslink_id}
                    href={item.links}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={item.media}
                      alt={item.title}
                      style={{ width: "25px", cursor: "pointer" }}
                    />
                  </a>
                ))}
            </div>
          </div>

          <div className="col-md-4 col-lg-4 footer-col">
            <h5>Services</h5>
            {Array.isArray(DropDown) && DropDown.length > 0 ? (
              DropDown.map((item, index) => (
                <div className="">

                  <ul>
                    <li onClick={() => handleClick(item)}><a className="cursorpointer"><i class="bi bi-check2 pe-3"></i>{item.heading}</a></li>
                  </ul>
                </div>))) : (null)}
          </div>

          <div className="col-md-4 col-lg-3 footer-col">
            <h5>{selectedLanguage.id === 1 ? 'Useful Link' : 'Lien utile'}</h5>
            <ul>
              <li onClick={Book} ><a href="#"><i className="bi bi-chevron-right pe-2"></i>{selectedLanguage.id === 1 ? 'Book a Consultation' : 'Réserver une consultation'}</a></li>
              <li onClick={checkEligibility}><a href="#"><i className="bi bi-chevron-right pe-2"></i>{selectedLanguage.id === 1 ? 'Check Eligibility' : 'Vérifier l’éligibilité'}</a></li>
              <li onClick={faq}><a href="#"><i className="bi bi-chevron-right pe-2"></i>FAQ</a></li>
              <li onClick={news}><a href="#"><i className="bi bi-chevron-right pe-2"></i>{selectedLanguage.id === 1 ? 'News' : 'Nouvelles'}</a></li>
              <li onClick={blog}><a href="#"><i className="bi bi-chevron-right pe-2"></i> {selectedLanguage.id === 1 ? 'Blog' : 'Blogue'}
              </a></li>
            </ul>
          </div>

          <div className="col-md-12 col-lg-3 colsm-12">
            <h5>{selectedLanguage.id === 1 ? 'Subscribe Our Newsletter' : 'Abonnez-vous à notre newsletter'}</h5>
            <form className="d-flex newsletter mt-3">
              <input type="email" className="form-control p-4" placeholder={selectedLanguage.id === 1 ? "Enter Email" : "Entrez votre e-mail"} />
              <button type="submit"><i className="bi bi-send-fill white"></i></button>
            </form>
          </div>
        </div>

        <div className="footer-bottom mt-4 d-flex justify-content-between align-items-center flex-column flex-md-row">
          <p class="mb-md-0">{selectedLanguage.id === 1 ? '© 2026 SBV Technologies. All Rights Reserved. ' : '© 2026 SBV Technologies. Tous droits réservés.'}</p>
          <div className="mt-2">
            <a href="#" class="text-white text-decoration-none me-3" onClick={termsAndConditions}>{selectedLanguage.id === 1 ? 'Terms & Condition' : 'Termes et conditions'}</a>
            <a href="#" class="text-white text-decoration-none me-3" onClick={PrivacyPolicy}>{selectedLanguage.id === 1 ? 'Privacy Policy ' : 'Politique de confidentialité'}</a>
            <a href="#" class="text-white text-decoration-none" onClick={ContactUs}>{selectedLanguage.id === 1 ? 'Contact Us' : 'Contactez-nous'}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;